import { Box, styled } from '@mui/material';

export const DashBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px dashed ${theme.palette.divider}`,
  width: '100%',
  padding: '24px',
  borderRadius: '8px',
}));
